import { render, staticRenderFns } from "./smokeType.vue?vue&type=template&id=01489d8b&"
import script from "./smokeType.vue?vue&type=script&lang=js&"
export * from "./smokeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports